import { useAction, useAtom } from '@reatom/npm-react'
import { css } from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { openTransactionDetailsDialogAction } from '@root/entities/transaction/atoms'
import {
  TransactionListItem,
  TransactionListItemSkeleton,
} from '@root/entities/transaction/ui'
import { tradingTransactionsModelAtom } from '@root/screens/trading/atoms/trading-transactions'
import { useTranslation } from '@root/shared/localization'
import { TradingList } from '@root/shared/trading'

import type { Transaction } from '@root/entities/transaction'

type Props = {}

export const TradingTransactionList: React.FC<Props> = () => {
  const { t } = useTranslation()
  const [transactionsStateAtom] = useAtom(tradingTransactionsModelAtom)
  const [transactionsState] = useAtom((ctx) => {
    const state = ctx.spy(transactionsStateAtom)
    return state.pipe(AsyncStateN.map((it) => it.data))
  })

  const [hasMore] = useAtom(transactionsStateAtom.hasMore)
  const [loadMoreState] = useAtom(transactionsStateAtom.loadMoreState)

  const retry = useAction(transactionsStateAtom.run)
  const loadMore = useAction(transactionsStateAtom.loadMore)
  const openTransactionDetailsDialog = useAction(
    openTransactionDetailsDialogAction,
  )

  return (
    <>
      <TradingList<Transaction.Transaction>
        state={transactionsState}
        getKey={(it) => it.id}
        emptyText={t('transaction.history.empty-description')}
        renderItem={(it) => (
          <TransactionListItem
            tx={it}
            onClick={openTransactionDetailsDialog}
            css={css`
              margin: 0;
            `}
          />
        )}
        renderSkeleton={() => <TransactionListItemSkeleton />}
        onRetry={retry}
        hasMore={hasMore}
        onLoadMore={loadMore}
        loadMoreState={loadMoreState}
      />
    </>
  )
}
